import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
export function useDebouncedValue(value, delay) {
  const $ = _c(4);
  const [debounced, setDebounced] = useState(value);
  let t0;
  let t1;
  if ($[0] !== delay || $[1] !== value) {
    t0 = () => {
      const t = setTimeout(() => setDebounced(value), delay);
      return () => clearTimeout(t);
    };
    t1 = [value, delay];
    $[0] = delay;
    $[1] = value;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
  return debounced;
}